import { useCallback, useMemo } from 'react';

const useTravelClass = ({ dispatch, value, initValue }) => {
  const onChange = useCallback(
    (selectedClass) => {
      dispatch({ type: 'TRAVEL_CLASS_CHANGE', payload: [selectedClass.value] });
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      value,
      defaultValue: value ? value[0] : undefined,
      onChange,
      isChanged: initValue !== value
    }),
    [value, onChange, initValue]
  );
};

export default useTravelClass;
